import { useEffect, useState } from "react";

/**
 * Phones, iPhone 13 (390px) first: below a tablet the app trades the sidebar
 * for a top bar with a drawer and draws its tables as cards, as the admin
 * panel does. Keep in sync with the `phone` mixin in src/styles/_media.scss.
 */
export const PHONE_QUERY = "(max-width: 767px)";

// jsdom (the tests) has no matchMedia: there the window is never a phone.
const supported = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function";

const matches = () => supported() && window.matchMedia(PHONE_QUERY).matches;

/** True while the window is phone-sized; follows rotation and resizing. */
const useIsPhone = () => {
  const [isPhone, setIsPhone] = useState(matches);

  useEffect(() => {
    if (!supported()) return undefined;
    const query = window.matchMedia(PHONE_QUERY);
    const onChange = () => setIsPhone(query.matches);
    onChange();
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return isPhone;
};

export default useIsPhone;
